import { useMutation } from "@tanstack/react-query";
import { formatTagNotificationMessage } from "../../../../../components/tags/utils";
import { NotificationsLevel } from "../../../../../lib/enums";
import { show } from "../../../../../notifications/notifications";
import api from "../../../../../services/api";

const useTagAllExtracted = (hash: string) => {
  const { mutate } = useMutation({
    mutationFn: (tags: string[]) => api.tagAllExtracted({ tags }, hash),
    onSuccess: ({ data }) => {
      const result: string[] = Array.from(
        new Set(
          data
            ?.flat()
            ?.map(({ added_tag }: { added_tag: string }) => added_tag)
            .filter(Boolean)
        )
      );
      const message = formatTagNotificationMessage("Added tag", result);
      show({
        level: NotificationsLevel.INFO,
        message
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: "Something went wrong. Please try again."
      });
    }
  });

  return { mutate };
};

export default useTagAllExtracted;
